export interface IFiltersRB {
  searchSelect: Set<string>;
  search: string;
  text: string;
  color: Set<string>;
  cost: Set<string>;
  powerCost: Set<string>;
  might: Set<string>;
  cardType: Set<string>;
  format: Set<string>;
  showAAs: boolean;
}

export default function getDefaultFilters(): IFiltersRB {
  return {
    searchSelect: new Set<string>(["name"]),
    search: "",
    text: "",
    color: new Set<string>(),
    cost: new Set<string>(),
    powerCost: new Set<string>(),
    might: new Set<string>(),
    cardType: new Set<string>(),
    format: new Set<string>(),
    showAAs: false,
  };
}
